import { CSSProperties, MouseEvent } from 'react';

import classes from './ImageBox.module.scss';

import DeleteIcon from '@mui/icons-material/Delete';
import { Button, Card, CardActions, CardContent, Typography } from '@mui/material';
import UrlImage from '../url-image/UrlImage';

type ImageBoxProps<T> = {
  title?: string;
  info?: string;
  info2?: string;
  image?: string;
  isSelected?: boolean;
  data: T;
  onClick?: (data: T) => void;
  onDeleteClick?: (data: T) => void;
  deteBtnText?: string;
  styles?: CSSProperties;
};

const ImageBox = <T,>({
  title,
  info,
  info2,
  image,
  isSelected,
  data,
  onClick,
  onDeleteClick,
  deteBtnText,
  styles,
}: ImageBoxProps<T>) => {
  const _onItemPressed = (event: MouseEvent<HTMLDivElement>) => {
    console.log('_onItemPressed:::', event.target);
    onClick && onClick(data);
  };

  return (
    <div className={classes.container} onClick={_onItemPressed}>
      <Card sx={{ maxWidth: 345 }} className={isSelected ? classes.selectedBorder : ''} style={styles}>
        {image ? (
          <UrlImage
            uri={image}
            fallbackSource="/fallback.jpg"
            // height={200}
            // width={300}
            signed={true}
            fillColor="#444"
            onLoad={() => console.log('Image loaded')}
            style={{
              minHeight: 100,
              minWidth: 200,
              padding: 10,
            }}
          />
        ) : null}
        {title || info ? (
          <CardContent>
            {title ? (
              <Typography gutterBottom variant="h5" component="div">
                {title}
              </Typography>
            ) : null}
            {info ? (
              <Typography variant="body1" sx={{ opacity: 0.7 }}>
                {info}
              </Typography>
            ) : null}
            {info2 ? (
              <Typography variant="body2" sx={{ opacity: 0.7 }}>
                {info2}
              </Typography>
            ) : null}
          </CardContent>
        ) : null}
        {onDeleteClick ? (
          <CardActions>
            {onDeleteClick ? (
              <Button
                size="small"
                onClick={() => onDeleteClick(data)}
                variant="contained"
                color="error"
                fullWidth
                sx={{ margin: 0 }}
              >
                <DeleteIcon />
                {deteBtnText || 'Delete'}
              </Button>
            ) : null}
          </CardActions>
        ) : null}
      </Card>
    </div>
  );
};

export default ImageBox;
